export default __webpack_public_path__ + "static/media/muslim.8168e9be1774a57157b09b286c37d857.png";